var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.jobdetaildescribe),function(item){return _c('div',{key:item.id,staticClass:"job-content job-widget"},[_c('div',{staticClass:"job-desc-title"},[_c('h4',[_vm._v(_vm._s(item.jobtitle))])]),_c('div',{staticClass:"job-description"},[_c('p',[_vm._v(_vm._s(item.jobcontent))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }